function normalizeLegacyDiffFilenameForId(filename: string): string {
  return filename.replace(/[^a-z0-9]/gi, '-');
}

function normalizePrV2DiffFilenameForId(filename: string): string {
  return filename.replace(/[^\w/-]/g, '-').replaceAll('/', '--');
}

export function getLegacyDiffFileElementId(filename: string): string {
  return `file-${normalizeLegacyDiffFilenameForId(filename)}`;
}

export function getPrV2DiffFileElementId(filename: string): string {
  return `pr-v2-file-${normalizePrV2DiffFilenameForId(filename)}`;
}

/**
 * Candidate DOM ids used by legacy and v2 diff renderers.
 * Prefer legacy first to keep existing behavior unchanged on v1 pages.
 */
export function getCandidateDiffFileElementIds(filename: string): string[] {
  return [getLegacyDiffFileElementId(filename), getPrV2DiffFileElementId(filename)];
}
